import React, { useState } from 'react';

const EMPLOYEES = [
  { id: 'E01', name: 'Alice Morgan', dept: 'Engineering', level: 'Senior', status: 'Active' },
  { id: 'E02', name: 'Bob Chen', dept: 'Marketing', level: 'Junior', status: 'Active' },
  { id: 'E03', name: 'Carol Davis', dept: 'Engineering', level: 'Lead', status: 'Active' },
  { id: 'E04', name: 'Dave Kim', dept: 'HR', level: 'Junior', status: 'Inactive' },
  { id: 'E05', name: 'Eve Wilson', dept: 'Finance', level: 'Senior', status: 'Active' },
  { id: 'E06', name: 'Frank Lee', dept: 'Engineering', level: 'Mid', status: 'Active' },
  { id: 'E07', name: 'Grace Park', dept: 'Marketing', level: 'Mid', status: 'Active' },
  { id: 'E08', name: 'Henry Brown', dept: 'Finance', level: 'Lead', status: 'Active' },
  { id: 'E09', name: 'Iris Patel', dept: 'Engineering', level: 'Senior', status: 'Inactive' },
  { id: 'E10', name: 'Jack Turner', dept: 'Engineering', level: 'Senior', status: 'Active' },
  { id: 'E11', name: 'Karen White', dept: 'Engineering', level: 'Senior', status: 'Active' },
  { id: 'E12', name: 'Leo Martinez', dept: 'Finance', level: 'Senior', status: 'Active' },
];

// Expected: Engineering + Active + Senior = E01(Alice), E10(Jack), E11(Karen) = 3
const EXPECTED_COUNT = 3;
const DEPTS = ['All', 'Engineering', 'Marketing', 'Finance', 'HR'];
const LEVELS = ['All', 'Junior', 'Mid', 'Senior', 'Lead'];
const STATUSES = ['All', 'Active', 'Inactive'];

export default function C05_DataCount({ onComplete }) {
  const [dept, setDept] = useState('All');
  const [level, setLevel] = useState('All');
  const [status, setStatus] = useState('All');
  const [answer, setAnswer] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const filtered = EMPLOYEES
    .filter(e => dept === 'All' || e.dept === dept)
    .filter(e => level === 'All' || e.level === level)
    .filter(e => status === 'All' || e.status === status);

  const handleSubmit = () => {
    if (!answer.trim()) return;
    setSubmitted(true);
    const got = parseInt(answer.trim());
    const pass = got === EXPECTED_COUNT;
    onComplete({
      score: pass ? 100 : 0,
      details: { count: { expected: String(EXPECTED_COUNT), got: answer.trim(), pass } },
      passed: pass,
    });
  };

  return (
    <div className="ab-challenge-ui">
      <div className="ab-toolbar">
        <div className="ab-filter-group"><label>Department:</label>
          <select value={dept} onChange={e => setDept(e.target.value)} className="ab-input ab-input-sm" disabled={submitted}>
            {DEPTS.map(d => <option key={d}>{d}</option>)}
          </select>
        </div>
        <div className="ab-filter-group"><label>Level:</label>
          <select value={level} onChange={e => setLevel(e.target.value)} className="ab-input ab-input-sm" disabled={submitted}>
            {LEVELS.map(l => <option key={l}>{l}</option>)}
          </select>
        </div>
        <div className="ab-filter-group"><label>Status:</label>
          <select value={status} onChange={e => setStatus(e.target.value)} className="ab-input ab-input-sm" disabled={submitted}>
            {STATUSES.map(s => <option key={s}>{s}</option>)}
          </select>
        </div>
        <span className="ab-row-count ab-row-count-highlight">{filtered.length} matching</span>
      </div>

      <div className="ab-table-wrap">
      <table className="ab-table">
        <thead>
          <tr><th>ID</th><th>Name</th><th>Department</th><th>Level</th><th>Status</th></tr>
        </thead>
        <tbody>
          {filtered.map(e => (
            <tr key={e.id}>
              <td>{e.id}</td><td><strong>{e.name}</strong></td><td>{e.dept}</td><td>{e.level}</td>
              <td><span className={`ab-badge ${e.status === 'Active' ? 'ab-badge-green' : 'ab-badge-red'}`}>{e.status}</span></td>
            </tr>
          ))}
          {filtered.length === 0 && <tr><td colSpan="5" className="ab-empty-row">No records match current filters.</td></tr>}
        </tbody>
      </table>
      </div>

      <div className="ab-answer-row">
        <label className="ab-label">Count (number of matching employees):</label>
        <input type="number" value={answer} onChange={e => setAnswer(e.target.value)} className="ab-input ab-answer-input"
          placeholder="Enter the count..." disabled={submitted} />
        {!submitted
          ? <button className="ab-action-btn" onClick={handleSubmit}>Submit Answer</button>
          : <div className="ab-submitted-badge">✓ Answer Submitted</div>
        }
      </div>
    </div>
  );
}
